import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

/**
 * Dados exibidos pelo alerta de limite de armazenamento.
 * Quem abre o modal (layout classic) já validou os critérios:
 * snapshot computado (computed_at preenchido) e uso >= 80% da cota.
 */
export interface StorageLimitAlertData
{
    usedPercent: number;
    planStorageGb: number;
}

@Component({
    selector: 'app-storage-limit-alert',
    templateUrl: './storage-limit-alert.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatIconModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StorageLimitAlertComponent
{
    readonly data: StorageLimitAlertData;

    constructor(
        @Inject(MAT_DIALOG_DATA) data: StorageLimitAlertData,
        private _dialogRef: MatDialogRef<StorageLimitAlertComponent>
    )
    {
        // Fallback seguro apenas contra dados ausentes — quem abre já validou.
        this.data = data ?? { usedPercent: 0, planStorageGb: 0 };
    }

    /**
     * Percentual de uso real (0-100), com fallback seguro.
     */
    get usedPercent(): number
    {
        const percent = Number(this.data?.usedPercent) || 0;
        return Math.min(Math.max(percent, 0), 100);
    }

    /**
     * Cota do plano em GB, com fallback seguro.
     */
    get planStorageGb(): number
    {
        return Number(this.data?.planStorageGb) || 0;
    }

    /**
     * Fecha o modal (única ação disponível — compra de armazenamento extra
     * chegará no futuro).
     */
    close(): void
    {
        this._dialogRef.close();
    }
}